import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

export const DevelopmentNeedCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  marginBottom: theme.spacing(1),
}));

export const RelatedAreaField = styled(Box)(() => ({
  width: '300px',
}));

export const DeadlineField = styled(Box)(() => ({
  width: '200px',
}));

export const ActionStepContainer = styled(Box)<{ noMarginBottom?: boolean }>(
  ({ theme, noMarginBottom }) => ({
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    marginBottom: noMarginBottom ? 0 : theme.spacing(1),
  }),
);

export const ActionStepsSectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const CheckboxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const ActionStepButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
